import { useQuery } from '@tanstack/react-query';

import { usePagination } from './usePagination';

import AuditLogsService, { AuditLogQueryFilterDto } from '@/services/AuditLogs';

export const GET_AUDIT_LOGS_QUERY_KEY: unknown[] = ['audit-logs'];

export function useGetAuditLogs(
  queryFilterDto?: Partial<AuditLogQueryFilterDto>,
) {
  const limit = queryFilterDto?.limit ?? 10;

  const {
    currentPage,
    totalPages,
    totalItems,
    hasNextPage,
    hasPreviousPage,
    nextPage,
    previousPage,
    setPage,
    setTotalPages,
    setTotalItems,
  } = usePagination();

  const { data, isFetching } = useQuery({
    queryKey: GET_AUDIT_LOGS_QUERY_KEY.concat([
      {
        ...queryFilterDto,
        page: currentPage,
        limit,
      },
    ]),
    queryFn: async () => {
      const response = await AuditLogsService.getAuditLogs({
        page: currentPage,
        limit,
        customer: queryFilterDto?.customer,
        action: queryFilterDto?.action,
      });

      setTotalPages(response.totalPages);
      setTotalItems(response.totalItems);

      return response;
    },
  });

  return {
    filteredLogs: data?.items ?? [],
    isLoading: isFetching,
    pagination: {
      currentPage,
      totalPages,
      totalItems,
      hasNextPage,
      hasPreviousPage,
      nextPage,
      previousPage,
      setPage,
    },
  };
}
